module.exports = __webpack_public_path__ + "img/pro_capture6.b7d71d8b.png";